import { Navigate, Outlet, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ requiredRole, allowedRoles }) {
  const location = useLocation();

  const token = sessionStorage.getItem('access_token');
  const storedUser = sessionStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;

  const isLoggedIn = !!token;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Role check
  if (allowedRoles && Array.isArray(allowedRoles)) {
    if (!allowedRoles.includes(user?.role)) {
      console.warn(
        `[Auth] Access denied. Required one of: ${allowedRoles.join(', ')}, Found: ${user?.role}`
      );
      return <Navigate to="/dashboard" replace />;
    }
  } else if (requiredRole && user?.role !== requiredRole) {
    console.warn(
      `[Auth] Access denied. Required: ${requiredRole}, Found: ${user?.role}`
    );
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
